"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfileOrientationMatchesDto = instanceOfProfileOrientationMatchesDto;
exports.ProfileOrientationMatchesDtoFromJSON = ProfileOrientationMatchesDtoFromJSON;
exports.ProfileOrientationMatchesDtoFromJSONTyped = ProfileOrientationMatchesDtoFromJSONTyped;
exports.ProfileOrientationMatchesDtoToJSON = ProfileOrientationMatchesDtoToJSON;
exports.ProfileOrientationMatchesDtoToJSONTyped = ProfileOrientationMatchesDtoToJSONTyped;
const ProfileOrientationMatchesOrientationDto_1 = require("./ProfileOrientationMatchesOrientationDto");
/**
 * Check if a given object implements the ProfileOrientationMatchesDto interface.
 */
function instanceOfProfileOrientationMatchesDto(value) {
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('orientations' in value) || value['orientations'] === undefined)
        return false;
    return true;
}
function ProfileOrientationMatchesDtoFromJSON(json) {
    return ProfileOrientationMatchesDtoFromJSONTyped(json, false);
}
function ProfileOrientationMatchesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfileId': json['nurseProfileId'],
        'orientations': (json['orientations'].map(ProfileOrientationMatchesOrientationDto_1.ProfileOrientationMatchesOrientationDtoFromJSON)),
    };
}
function ProfileOrientationMatchesDtoToJSON(json) {
    return ProfileOrientationMatchesDtoToJSONTyped(json, false);
}
function ProfileOrientationMatchesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfileId': value['nurseProfileId'],
        'orientations': (value['orientations'].map(ProfileOrientationMatchesOrientationDto_1.ProfileOrientationMatchesOrientationDtoToJSON)),
    };
}
//# sourceMappingURL=ProfileOrientationMatchesDto.js.map